exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notes-card[data-v-31d52807] {\n  border-radius: 16px;\n  border: 1px solid #E5E7EB !important;\n  overflow: hidden;\n}\n.notes-card .card-title[data-v-31d52807] {\n  font-size: 14px;\n  color: #111827;\n  letter-spacing: 0.05em;\n}\n.notes-card .h-100-content[data-v-31d52807] {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n.notes-card .h-100-content[data-v-31d52807] .kv-native-input {\n  min-height: 130px;\n}", ""]);

// exports
